export default "__VITE_ASSET__lDtiIB74__"